import { render, staticRenderFns } from "./ComplaintsSample.vue?vue&type=template&id=7b859264"
import script from "./ComplaintsSample.vue?vue&type=script&lang=js"
export * from "./ComplaintsSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports